<div class="alert-large">
  <div class="alert-large__text" brtRoughText [innerHtml]="text" [state]="'run'" type="highlight" selector="em  "></div>
</div>
